import TypedNativeModules from "../internal/TypedNativeModules";

export async function logTapButton(screenName: string, elementName: string): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.logTapButton) {
    return;
  }
  await tareBridge.logTapButton(screenName, elementName);
}
